import React from 'react';
import IncidentListPage from '../components/Incident/IncidentListPage';

const IncidentPage = () => {
  return <IncidentListPage></IncidentListPage>
};

export default IncidentPage;
